import React, { useEffect, useState } from "react";
import { SpaceTypes } from "../../Constants/Interfaces";

interface SpaceStepFourType {
  space: SpaceTypes;
  setStepBack: Function;
  onChange: Function;
  priceError?: string;
}

const SpaceInfoStepFour: React.FC<SpaceStepFourType> = ({
  space,
  setStepBack,
  onChange,
  priceError = "",
}) => {
  const [data, setData] = useState<SpaceTypes>({});

  useEffect(() => {
    setData(space);
  }, [space]);

  return (
    <>
      <div className="">
        <div className="row">
          <div className="col-md-6 col-sm-6 col-xs-12">
            <div className="form-group">
              <label>
                Space Rent Price (Per Hour)
                <span className="required-star">*</span>
              </label>
              <input
                type="number"
                min={1}
                className="form-control"
                placeholder="Price per hour in USD, e.g. 50"
                name="space_rent"
                value={data.ratePerHour}
                onChange={(e) => onChange("ratePerHour", e.target.value)}
              />
              {priceError && <span className="error">{priceError}</span>}
            </div>
          </div>
          <div className="col-md-6 col-sm-6 col-xs-12">
            <div className="form-group">
              <label>Minimum Booking (Hours)</label>
              <input
                type="number"
                className="form-control"
                placeholder="Fewest hours per booking, e.g. 2"
                name="max_booking_hours"
                value={data.minHours}
                onChange={(e) => onChange("minHours", e.target.value)}
              />
            </div>
          </div>
          <div className="col-md-6 col-sm-6 col-xs-12">
            <div className="form-group">
              <label>Discount (10% off)</label>
              <input
                type="number"
                className="form-control"
                placeholder="Hours to unlock discount, e.g. 8"
                name="minimum_discount"
                value={data.discountHours}
                onChange={(e) => onChange("discountHours", e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SpaceInfoStepFour;
